export const MAX_IMAGE_SIZE_MB = 1024;
export const MAX_IMAGE_THUMBNAIL_DIMENSION = 300;
export const MAX_IMAGE_THUMBNAIL_SIZE_MB = 10;

export const MAX_AVATAR_SIZE_MB = 10;
export const MAX_AVATAR_THUMBNAIL_DIMENSION = 128;
export const MAX_AVATAR_DIMENSION = 400;
